import React from "react";
interface MetricsData {
  totalOrders: number;
  totalOngoingOrders: number;
  totalPaidOrders: number;
  totalUnpaidOrders: number;
}

interface MetricsProps {
  metrics: MetricsData;
}
const MetricsCard: React.FC<MetricsProps> = ({ metrics }) => {
  return (
    <div className="my-7">
      <div className="flex lg:grid lg:grid-cols-4 gap-4 overflow-x-auto scrollbar-hide lg:overflow-visible whitespace-nowrap">
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
          Total Orders
            <button type="button"></button>
          </p>
          <h1 className="text-[#2B2B2B] text-[36px] font-extrabold">
            {metrics?.totalOrders || 0}
          </h1>
        </section>

        {/* Orders Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
          Ongoing Orders
            <button type="button"></button>
          </p>
          <h1 className="text-[#F59E0B] text-[36px] font-extrabold">
            {metrics?.totalOngoingOrders|| 0}
          </h1>
        </section>

        {/* Withdrawals Card */}
        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
          Paid Orders
            <button type="button"></button>
          </p>
          <h1 className="text-[#16A34A] text-[36px] font-extrabold">
            {" "}
            {metrics?.totalPaidOrders || 0}
          </h1>
        </section>
        {/* Out Escrow Card */}

        <section className="bg-white border border-[#C9C9C9] rounded-3xl p-4 flex flex-col justify-between">
          <p className="font-bold text-[14px] text-[#475467]">
          Unpaid Orders
            <button type="button"></button>
          </p>
          <h1 className="text-[#9AC12A] text-[36px] font-extrabold">
            {metrics?.totalUnpaidOrders || 0}
          </h1>
        </section>
      </div>
    </div>
  );
};

export default MetricsCard;
